module.exports = __webpack_public_path__ + "static/media/macbookVizi.049575fd.png";